// Action creator
export const setMenuVisible = isMenuVisible => {
    // Return an action
    return {
        type: 'MENU_VISIBLE',
        payload: isMenuVisible
    };
};

export const setPageVisible = isPageVisible => {
    // Return an action
    return {
        type: 'PAGE_VISIBLE',
        payload: isPageVisible
    };
};

export const playCutSceneVideo = cutSceneVideo => {
    // Return an action
    return {
        type: 'CUT_SCENE_VIDEO',
        payload: cutSceneVideo
    };
};

export const pageChange = pageInfo => {
    return {
        type: 'PAGE_CHANGE',
        payload: pageInfo
    }
}

export const languageChange = language => {
    return {
        type: 'LANGUAGE_CHANGE',
        payload: language
    }
}